import {
  useMutation,
  useQueryClient,
  UseMutationResult,
  UseMutationOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type { OrganizationMembershipDto, ResponseDto } from "@mimber/schema"
import { membersKeys } from "../members.utils"

interface ReactivateMemberOptions extends Omit<
  UseMutationOptions<ResponseDto<OrganizationMembershipDto>, Error, void>,
  "mutationFn"
> {}

export const useReactivateMember = (
  memberUuid: string,
  options: ReactivateMemberOptions = {}
): UseMutationResult<ResponseDto<OrganizationMembershipDto>, Error, void> => {
  guardAppUsage("mimber-organization", "useReactivateMember")

  const { server } = useServerContext()
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: async () => {
      const response = await server.patch<
        ResponseDto<OrganizationMembershipDto>
      >(`members/${memberUuid}/reactivate`)
      return response.data
    },
    onSuccess: (response, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({ queryKey: membersKeys.findAll() })
      queryClient.invalidateQueries({
        queryKey: membersKeys.findOne(memberUuid),
      })
      options?.onSuccess?.(response, variables, onMutateResult, context)
    },
  })
}
